// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1ouAX","Success":"Button_Success__1BGa4","Danger":"Button_Danger__18hgc","Info":"Button_Info__30utq"};